export default {
  message: {
    introduce: 'A Simple Vue Plugin for Baberrage.',
    start: 'GET STARTED',
    doc: 'DOC',
    title1: 'Easy',
    content1: 'Easy to use. Only a few words of code.',
    title2: 'High Performance',
    content2: '100 messages also can keep on 60FPS.',
    title3: 'Independent',
    content3: 'You can manage the messages by yourself via Vuex'
  }
}